{
  "name": "incopesca-digital-dashboard-v2",
  "version": "1.0.1",
  "scripts": {
    "ng": "ng",
    "start": "npm run serverless:dev",
    "serve": "ng serve",
    "build": "ng build -c production",
    "build:dev": "ng build -c development",
    "build:local": "ng build -c local",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --code-coverage --browsers=ChromeHeadlessCI --no-watch",
    "prettier-quick": "pretty-quick",
    "prettier:fix": "prettier --ignore-unknown --write . -c && eslint . --fix",
    "eslint": "ng lint",
    "prepare": "husky install",
    "lint": "ng lint",
    "gen": "ng g",
    "compodoc:build": "compodoc -p tsconfig.doc.json",
    "compodoc:build-and-serve": "compodoc -p tsconfig.doc.json -s",
    "compodoc:serve": "compodoc -s",
    "compodoc": "npx compodoc -p tsconfig.doc.json",
    "serverless:dev": "ng build -c local && npm run serverless:serve",
    "serverless:serve": "serverless offline start --noPrependStageInUrl",
    "serverless:deploy:prod": "serverless deploy --stage production",
    "serverless:deploy:dev": "serverless deploy --stage dev",
    "serverless:terminate:dev": "serverless remove --stage dev",
    "serverless:terminate:prod": "serverless remove --stage production",
    "serverless:invoke:dev": "serverless invoke --stage dev --function api --path data.json",
    "serverless:invoke:local": "serverless invoke local --function api --path data.json",
    "serverless": "serverless",
    "console": "serverless --console",
    "dpdm": "dpdm -T --no-warning --no-tree ./src/main.ts",
    "serve:ssr:incopesca-digital-dashboard-v2": "node dist/incopesca-digital-dashboard-v2/server/server.mjs"
  },
  "prettier": {
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.0.6",
    "@angular/cdk": "^20.0.5",
    "@angular/common": "^20.0.0",
    "@angular/compiler": "^20.0.0",
    "@angular/core": "^20.0.0",
    "@angular/forms": "^20.0.0",
    "@angular/material": "^20.0.5",
    "@angular/platform-browser": "^20.0.0",
    "@angular/platform-server": "^20.0.0",
    "@angular/router": "^20.0.0",
    "@angular/ssr": "^20.0.5",
    "@auth0/angular-jwt": "^5.2.0",
    "@compodoc/compodoc": "^1.1.19",
    "aws-serverless-express": "^3.4.0",
    "echarts": "^5.6.0",
    "express": "^5.1.0",
    "luxon": "^3.7.1",
    "ngx-echarts": "^20.0.1",
    "rxjs": "~7.8.0",
    "serverless-api-compression": "^1.0.1",
    "serverless-associate-waf": "^1.2.1",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.3",
    "@angular-eslint/builder": "20.7.0",
    "@angular-eslint/eslint-plugin": "20.7.0",
    "@angular-eslint/eslint-plugin-template": "20.7.0",
    "@angular-eslint/schematics": "20.7.0",
    "@angular-eslint/template-parser": "20.7.0",
    "@angular/build": "^20.0.5",
    "@angular/cli": "^20.0.5",
    "@angular/compiler-cli": "^20.0.0",
    "@angular/platform-browser-dynamic": "^20.3.2",
    "@types/express": "^5.0.1",
    "@types/jasmine": "~5.1.0",
    "@types/luxon": "^3.6.2",
    "@types/node": "^20.17.19",
    "@typescript-eslint/eslint-plugin": "7.11.0",
    "@typescript-eslint/parser": "7.11.0",
    "dpdm": "^3.14.0",
    "eslint": "^8.57.0",
    "husky": "8.0.0",
    "jasmine-core": "~5.7.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "2.7.1",
    "pretty-quick": "3.1.3",
    "serverless": "^3.40.0",
    "serverless-apigw-binary": "^0.4.4",
    "serverless-offline": "^13.6.0",
    "typescript": "~5.8.2"
  },
  "overrides": {
    "serverless": {
      "ajv": "8.18.0",
      "tar": "7.5.11",
      "@serverless/dashboard-plugin": {
        "@serverless/utils": {
          "file-type": "^22.0.0"
        }
      }
    },
    "@nx/devkit": {
      "minimatch": "9.0.7"
    },
    "nx": {
      "minimatch": "9.0.7"
    },
    "@angular/build": {
      "tinyglobby": {
        "picomatch": "4.0.4",
        "fdir": {
          "picomatch": "4.0.4"
        }
      }
    },
    "@compodoc/compodoc": {
      "@angular-devkit/schematics": {
        "@angular-devkit/core": {
          "ajv": "8.18.0",
          "picomatch": "4.0.4"
        }
      },
      "uuid": "11.1.1"
    },
    "karma": {
      "tmp": "0.2.4"
    }
  }
}
